export default "__VITE_ASSET__2ed0af56__"